import * as Sentry from '@sentry/angular';

export namespace NSentry {
    export const DEFAULT_CONFIG: Sentry.BrowserOptions = {
        // Set dsn in project.yaml
        dsn: undefined,
        integrations: [
            // Registers and configures the Tracing integration,
            // which automatically instruments your application to monitor its
            // performance, including custom Angular routing instrumentation
            Sentry.browserTracingIntegration({
                enableInp: true
            })
            // Registers the Replay integration,
            // which automatically captures Session Replays
            // Commented out for now because replays are broken on Sentry panel side and its not a part of task scope
            // Sentry.replayIntegration()
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.001,
        profilesSampleRate: 0.001,
        replaysOnErrorSampleRate: 0.001,
        replaysSessionSampleRate: 0.001

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        // replaysSessionSampleRate: 0.1,
        // replaysOnErrorSampleRate: 1.0
    };

    export interface IUserData {
        // customer id, sentry documentation also allows to capture user emails but we don't do it here for privacy reasons.
        id?: number;
        logged_in?: boolean;
        quote_id?: number;
    }
}
